<template>
  <div class="drawerLayer" v-show="visible">
    <div class="mask" @click="ok()"></div>
    <div class="bottomDrawer white_bg">
      <div class="generalPagePaddingH">
        <header class="header paddingV16">
          <div class="flexLayout">
            <!-- <div style="width: 16px"></div> -->
            <div class="flexItem grey10 fWeight600">
              {{ title }} <span class="multipleTips">可多选</span>
            </div>
<!--            <div style="width: 16px">-->
<!--              <i class="icon closeIcon" @click="close()"></i>-->
<!--            </div>-->
          </div>
        </header>
        <div class="body" style="margin-top: 10px; padding-bottom: 34px">
          <div style="height: 100%">
            <span
              class="areaTag"
              v-for="jobItem in jobList"
              :key="jobItem"
              :class="{
                active: dataMixedUtils.array.existElement(
                  jobItem,
                  selectJobList
                ),
              }"
              @click="selectJob(jobItem)"
            >
              {{ jobItem }}
            </span>
          </div>
          <div class="operationArea" style="height: 48px; padding-bottom: 34px">
            <div class="generalPagePaddingH" style="padding-top: 6px">
              <div class="flexLayout">
                <div style="width: 122px">
                  <button class="button block clearButton" @click="clear()">
                    清除
                  </button>
                </div>
                <div class="flexItem marginL8">
                  <button class="button block okButton" @click="ok()">
                    确定
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawerPart from "../../part/drawerPart";
import dataMixedUtils from "@util/dataMixedUtils";
import requestManager from "@comp/platformApi/requestManager.js";
const config = {
  apiConfig: {
    list: {
      url: "/portal/recruit/jobs/getJobName",
      dataPath: "data.records",
      totalPagePath: "data.pages",
      dataColumnMapping: {
        // userName : 'name''
      },
    },
    get: {
      url: "",
      dataColumnMapping: {
        // userName : 'name'
      },
    },
  },
};

export default {
  name: "drawerTemplate",
  extends: drawerPart,
  props: {
    title: {
      type: String,
      default: "职业筛选",
    },
  },
  data() {
    return {
      apiConfig: config.apiConfig,
      dataMixedUtils: dataMixedUtils,
      visible: false,
      jobList: [
        "不限",
        "幼师教育",
        "园长",
        "体育老师",
        "语文老师",
        "保安",
        "后勤老师",
        "班主任",
        "你好",
      ],
      selectJobList: [],
    };
  },
  methods: {
    open(data) {
      this.visible = true;
    },
    selectJob(jobItem) {
      if (dataMixedUtils.array.existElement(jobItem, this.selectJobList)) {
        this.selectJobList = dataMixedUtils.array.removeElement(
          this.selectJobList,
          jobItem
        );
      } else {
        this.selectJobList.push(jobItem);
      }
    },
    clear() {
      this.selectJobList = [];
      this.$emit("close");

    },
    ok() {
      this.$emit("change", this.selectJobList.join(","));
      this.close();
    },
    formatNames(list) {
      let datas = [];
      for (let i = 0; i < list.length; i++) {
        datas.push(list[i].name);
      }
      return datas;
    },
  },
  mounted() {
    let reqOptions = this.apiConfig.list;
    requestManager.request(reqOptions, (error, result) => {
      if (error) {
        return;
      }
      if (result.errorCode) {
        appHelper.showMessage(result.msg);
        return;
      }
      let list = result.data;
      this.jobList = this.formatNames(list);
    });
  },
};
</script>

<style lang="scss" scoped>
.header {
  .closeIcon {
    width: 14px;
    height: 14px;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC");
  }
}

.multipleTips {
  font-size: 10px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 19px;
  color: #ff4d48;

}

.areaTag {
  display: inline-block;
  //width: 68px;
  height: 26px;
  line-height: 26px;
  //padding: 0 20px;
  padding: 0 14px;
  background: #f2f3f8;
  border-radius: 4px;
  text-align: center;
  color: #5b616c;
  font-size: 14px;
  margin-right: 8px;
  margin-bottom: 16px;

  &.active {
    background: #ffc439;
    color: white;
  }
}

.operationArea {
  .button {
    height: 36px;
    line-height: 36px;
    border-radius: 18px;
    font-size: 14px;
  }
  .clearButton {
    background: #f2f3f8;
    color: #333;
  }
  .okButton {
    background: #ffa724;
    color: white;
  }
}
</style>
